import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CdsLangService } from '@cds/ng-core/lang';
import { CdsIconModule } from '@cds/ng-web-components/icon';

import { AnnouncementMarkdownService } from './announcement-markdown.service';
import { PortalAnnouncement } from './release-notification.model';

@Component({
  selector: 'app-release-notification-card',
  templateUrl: './release-notification-card.component.html',
  styleUrls: ['./release-notification-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdsIconModule],
})
export class ReleaseNotificationCardComponent implements OnChanges {
  private langService = inject(CdsLangService);
  private markdownService = inject(AnnouncementMarkdownService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  @Input({ required: true }) announcement!: PortalAnnouncement;

  html = '';
  private currentLang = this.langService.currentLang;

  constructor() {
    this.langService.currentLanguageObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(lang => {
      this.currentLang = lang;
      this.updateHtml();
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['announcement']) {
      this.updateHtml();
    }
  }

  private updateHtml(): void {
    if (!this.announcement) {
      this.html = '';
      return;
    }
    const source = this.currentLang === 'zh' ? this.announcement.content.zhHant : this.announcement.content.en;
    this.html = this.markdownService.render(source);
  }
}
